import React, {useState, useEffect, useRef} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Menu from "../../../components/layout/menu/index";
import FilterInput from "../../../components/filters/filterInput";
import updateImage from "../../../assets/images/icons/shared/updateImage.svg"
import PdfCard from "../../../components/card/pdfCard";
import imageNews from "../../../assets/images/icons/shared/imageNoticias.svg"
import NewsCard from "../../../components/card/newsCard";
import EditPdfModal from "../../../components/shared/modals/editPdfModal";
import EditNewsModal from "../../../components/shared/modals/editNewsModal";
import { getManuals, createManual, deleteManual, updateManual } from "../../../client/manuals/index"
import CreatePdfModal from "../../../components/shared/modals/createPdfModal";
import DateFilterButton from "../../../components/filters/dateFilterButton";
import ModalDelete from "../../../components/shared/modals/modalDelete";
import ModalSuccess from "../../../components/shared/modals/modalSuccess";
import ModalAlertWarning from "../../../components/shared/modals/modalAlertWarning";
import { getNews, deleteNews} from "../../../client/news/index"
import ResetFilters from "../../../components/filters/resetFilters";
import ContentLoader from "react-content-loader";
import { MODALS } from "../../../config/images";
import { axiosInstance } from '../../../client';
import { validateImageFile } from "../../../utils/imageValidation";
import { useBrokenImages } from "../../../hooks/useBrokenImages";
import NewsImagePlaceholder from "../../../components/shared/newsImagePlaceholder";

// Peso máximo permitido para los manuales PDF; cambiar aquí si se amplía el límite
const MAX_PDF_SIZE_MB = 50;
const MAX_PDF_SIZE_BYTES = MAX_PDF_SIZE_MB * 1024 * 1024;

const PdfCardLoader = () => (
  <div className="flex flex-col items-center justify-center gap-3">
    <div className="relative overflow-hidden drop-shadow-manual rounded-lg h-[320px] w-[230px]">
      <ContentLoader 
        speed={2}
        width={230}
        height={320}
        viewBox="0 0 230 320"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="8" ry="8" width="230" height="320" />
      </ContentLoader>
    </div>
  </div>
);

const NewsCardLoader = () => (
  <div className="w-[267px] h-[314px]">
    <ContentLoader 
      speed={2}
      width={267}
      height={314}
      viewBox="0 0 267 314"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="0" y="0" rx="12" ry="12" width="267" height="185" />
      <rect x="16" y="200" rx="4" ry="4" width="180" height="18" />
      <rect x="16" y="230" rx="3" ry="3" width="235" height="10" />
      <rect x="16" y="250" rx="3" ry="3" width="220" height="10" />
      <rect x="16" y="270" rx="6" ry="6" width="70" height="24" />
      <rect x="176" y="270" rx="6" ry="6" width="90" height="24" />
    </ContentLoader>
  </div>
);

export default function KnowUs() {
  const navigate = useNavigate();
  const location = useLocation(); 

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [currentPdfIndex, setCurrentPdfIndex] = useState(0);
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const pdfCarouselRef = useRef(null);
  const newsCarouselRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);


const toggleMenu = (open) => {
  setIsMenuOpen(prev => (typeof open === 'boolean' ? open : !prev));
};


  const [isEditNewsModalOpen, setIsEditNewsModalOpen] = useState(false);
  const [editingNews, setEditingNews] = useState(null);
  const [editingNewsTitle, setEditingNewsTitle] = useState("");
  const [editingNewsDescription, setEditingNewsDescription] = useState("");
  const [editingNewsImage, setEditingNewsImage] = useState("");
  const [editingNewsImageFile, setEditingNewsImageFile] = useState(null);

  const [maxVisibleCards, setMaxVisibleCards] = useState(3);
  const [maxVisibleNews, setMaxVisibleNews] = useState(3);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [manuals, setManuals] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingPdf, setEditingPdf] = useState(null);
  const [editingTitle, setEditingTitle] = useState("");
  const [originalTitle, setOriginalTitle] = useState(""); 
  const [isSaving, setIsSaving] = useState(false);

  const [viewModalUrl, setViewModalUrl] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewModalBlobUrl, setViewModalBlobUrl] = useState(null);
  const [viewModalError, setViewModalError] = useState(false);

  const [showEditSuccess, setShowEditSuccess] = useState(false);
  const [editSuccessMessage, setEditSuccessMessage] = useState("");

  const [showModalSuccess, setShowModalSuccess] = useState(false);

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [manualToDelete, setManualToDelete] = useState(null);

  const [showVisibilitySuccess, setShowVisibilitySuccess] = useState(false);
  const [visibilityMessage, setVisibilityMessage] = useState("");

  const [fileToUpload, setFileToUpload] = useState(null);
  const fileInputRef = useRef(null);

  const [news, setNews] = useState([]);
  const [isNewsLoading, setIsNewsLoading] = useState(true);
  const [newsError, setNewsError] = useState(null);

  const [isCreateNewsModalOpen, setIsCreateNewsModalOpen] = useState(false);
  const [newNewsImage, setNewNewsImage] = useState("");
  const [newNewsTitle, setNewNewsTitle] = useState("");
  const [newNewsDescription, setNewNewsDescription] = useState("");
  const [newNewsImageFile, setNewNewsImageFile] = useState(null);
  const { hasImage, markBroken } = useBrokenImages();

  const [newsToDelete, setNewsToDelete] = useState(null);
  const [showNewsDeleteModal, setShowNewsDeleteModal] = useState(false);
  const [deleteNewsSuccess, setDeleteNewsSuccess] = useState(false);

  const [showNewsVisibilitySuccess, setShowNewsVisibilitySuccess] = useState(false);
  const [newsVisibilityMessage, setNewsVisibilityMessage] = useState("");

  const [dateFilters, setDateFilters] = useState({
    createDateFrom: "",
    createDateTo: ""
  });
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchingNews, setIsSearchingNews] = useState(false);

  useEffect(() => {
    if (location.state?.showSuccess && location.state?.message) {
      setModalMessage(location.state.message);
      setShowModalSuccess(true);
      
      navigate(location.pathname, { replace: true, state: {} });
      
      fetchNews();
    }
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    const calculateVisibleCards = () => {
      const screenWidth = window.innerWidth;
      
      const adjustedWidth = isMenuOpen 
        ? screenWidth - (screenWidth >= 1280 ? screenWidth * 0.207 : screenWidth >= 1024 ? screenWidth * 0.237 : 0)
        : screenWidth;
      
      // Para PDF cards
      if (adjustedWidth < 570) {
        setMaxVisibleCards(1);
      } else if (adjustedWidth < 800) {
        setMaxVisibleCards(2);
      } else if (adjustedWidth < 1100) {
        setMaxVisibleCards(3);
      } else {
        setMaxVisibleCards(4);
      }
      
      // Para News cards
      if (adjustedWidth < 642) {
        setMaxVisibleNews(1);
      } else if (adjustedWidth < 936) {
        setMaxVisibleNews(2);
      } else if (adjustedWidth < 1256) {
        setMaxVisibleNews(3);
      } else if (adjustedWidth < 1570) {
        setMaxVisibleNews(4);
      }  else if (adjustedWidth < 1590) {
        setMaxVisibleNews(5);
      } 
    };

    calculateVisibleCards();

    const handleResize = () => {
      calculateVisibleCards();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMenuOpen]); 

  // ⭐ Effect que carga el PDF como blob cuando se abre el modal
  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    setViewModalBlobUrl(null);
    setViewModalError(false);

    if (!viewModalUrl || !isViewModalOpen) return;

    axiosInstance.get(viewModalUrl, { responseType: 'blob' })
      .then(response => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setViewModalBlobUrl(objectUrl);
      })
      .catch(err => {
        console.error('Error al cargar el documento:', err);
        if (!cancelled) setViewModalError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [viewModalUrl, isViewModalOpen]);

  const fetchNews = async (searchTerm = "", dateFilters = {}) => {
    try {
      setIsNewsLoading(true);
      const response = await getNews(searchTerm, dateFilters.createDateFrom, dateFilters.createDateTo);
      if (response.data && response.data.news) {
        setNews(response.data.news);
      }
      setIsNewsLoading(false);
    } catch (err) {
      setNewsError("Error al cargar las noticias");
      setIsNewsLoading(false);
      console.error("Error fetching news:", err);
    }
  };

const handleNewsVisibilityChange = (isVisible, title) => {
  const message = isVisible 
    ? `La noticia ha sido mostrada con éxito` 
    : `La noticia ha sido ocultada con éxito`;
  
  setNewsVisibilityMessage(message);
  setShowNewsVisibilitySuccess(true);
};

const handleVisibilityChange = (isVisible, title) => {
  const message = isVisible 
    ? `El manual ha sido mostrado con éxito` 
    : `El manual ha sido ocultado con éxito`;
  
  setVisibilityMessage(message);
  setShowVisibilitySuccess(true);
};
  const handleNewNewsImageSelect = async (e) => {
    const input = e.target;
    const file = input.files?.[0];
    if (!file) return;

    const { isValid, message } = await validateImageFile(file);
    if (!isValid) {
      setModalMessage(message);
      setShowModalAlertWarning(true);
      input.value = '';
      return;
    }

    setNewNewsImageFile(file);
    setNewNewsImage(URL.createObjectURL(file));
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file || file.type !== "application/pdf") {
      setModalMessage("Por favor, seleccione un archivo PDF válido.");
      setShowModalAlertWarning(true);
      resetFileSelection();
      return;
    }

    if (file.size > MAX_PDF_SIZE_BYTES) {
      setModalMessage(`El archivo no debe superar los ${MAX_PDF_SIZE_MB} MB.`);
      setShowModalAlertWarning(true);
      resetFileSelection();
      return;
    }

    setFileToUpload(file);
    setIsCreateModalOpen(true);
  };

  const resetFileSelection = () => {
    setFileToUpload(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const fetchManuals = async (searchTerm = "", dateFilters = {}) => {
    try {
      setIsLoading(true);
      const response = await getManuals("KnowUs", searchTerm, dateFilters.createDateFrom, dateFilters.createDateTo);
      if (response.data && response.data.manuals) {
        setManuals(response.data.manuals);
      }
      setIsLoading(false);
    } catch (err) {
      setError("Error al cargar los manuales");
      setIsLoading(false);
      console.error("Error fetching manuals:", err);
    }
  };

  useEffect(() => {
    fetchManuals("", dateFilters);
    fetchNews("", dateFilters);
  }, []);

  const handleCreateManual = async (formData) => {
    try {
      const response = await createManual(formData);
      if (response.data && response.data.manual) {
      setManuals(prev => [response.data.manual, ...prev]);
      return response.data;
      }
    } catch (error) {
      console.error("Error creating manual:", error);
      throw error;
    }
  };

  const handleDeleteManual = async (manualId) => {
    try {
      const response = await deleteManual(manualId);
      if (response.data && response.data.message) {
        setManuals(prev => prev.filter(manual => manual.id !== manualId));
        setShowModalDelete(false);
        setManualToDelete(null);
        setModalMessage("Manual eliminado correctamente");
        setShowModalSuccess(true);
      }
    } catch (error) {
      console.error("Error deleting manual:", error);

      setModalMessage(error.response?.data?.message || "Error al eliminar el manual");
      setShowModalAlertWarning(true);
      
      setShowModalDelete(false);
      setManualToDelete(null);    }
  };

  const handleEditClick = (pdf) => {
    setEditingPdf(pdf);
    setEditingTitle(pdf.title);
    setOriginalTitle(pdf.title); 
    setIsEditModalOpen(true);
    setIsSaving(false);
  }

  const handleSaveChanges = async () => {
    try {
      if (editingTitle === originalTitle) {
        setIsEditModalOpen(false);
        return;
      }

      if (editingTitle.length > 50) {
        setModalMessage("El título no puede exceder los 50 caracteres.");
        setShowModalAlertWarning(true);
        return;
      }

      setIsSaving(true);

      const formData = new FormData();
      formData.append('title', editingTitle);
      formData.append('module', 'KnowUs');
      
      const response = await updateManual(editingPdf.id, formData);
      
      if (response.data && response.data.manual) {
        await fetchManuals(searchTerm, dateFilters);

        setIsEditModalOpen(false);
        
        setEditSuccessMessage("Manual editado correctamente");
        setShowEditSuccess(true);
      }
    } catch (error) {
      console.error("Error updating manual:", error);
      setModalMessage(error.response?.data?.message || "Error al editar el manual");
      setShowModalAlertWarning(true);
    } finally {
      setIsSaving(false); 
    }
  };

  const handleDeleteClick = (manual) => {
    setManualToDelete(manual);
    setShowModalDelete(true);
  };

  const confirmDelete = () => {
    if (manualToDelete) {
      handleDeleteManual(manualToDelete.id);
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setIsSearching(term.trim() !== ""); 
    setIsSearchingNews(term.trim() !== ""); 
    
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    const newTimeout = setTimeout(() => {
      fetchManuals(term, dateFilters);
      fetchNews(term, dateFilters);
    }, 500);
    
    setSearchTimeout(newTimeout);
  };

  const handleDateRangeChange = ({ startDate, endDate }) => {
    const newDateFilters = {
      createDateFrom: startDate || "",
      createDateTo: endDate || ""
    };
    
    setDateFilters(newDateFilters);
    
    fetchManuals(searchTerm, newDateFilters);
    fetchNews(searchTerm, newDateFilters);
  };
 
  const handleCreateNews = async () => {
    try {
      if (newNewsTitle.length > 50) {
        setModalMessage("El título no puede exceder los 50 caracteres.");
        setShowModalAlertWarning(true);
        return;
      }

      const newsData = {
        title: newNewsTitle,
        advance: newNewsDescription,
        imageListFile: newNewsImageFile, 
      };
      
      navigate('/crear-detalle-noticia', { 
        state: { 
          newsData,
          isCreating: true 
        } 
      });
      
      setIsCreateNewsModalOpen(false);
      resetNewsForm();
    } catch (error) {
      console.error("Error preparing news:", error);
      setModalMessage("Error al preparar la noticia");
      setShowModalAlertWarning(true);
    }
  };

  const handleEditNewsClick = (newsItem) => {
    setEditingNews(newsItem);
    setEditingNewsTitle(newsItem.title);
    setEditingNewsDescription(newsItem.advance); 
    setEditingNewsImage(newsItem.image_list); 
    setEditingNewsImageFile(null);
    setIsEditNewsModalOpen(true);
  };

  const handleImageChange = (imageUrl, imageFile = null) => {
    setEditingNewsImage(imageUrl);
    if (imageFile) {
      setEditingNewsImageFile(imageFile);
    }
  };
  
  const handleSaveNewsChanges = () => {
    navigate(`/actualizar-noticia/${editingNews.id}`, {
    state: {
      editedTitle: editingNewsTitle,
      editedDescription: editingNewsDescription,
      editedImage: editingNewsImage,
      editedImageFile: editingNewsImageFile
    }
    });
  };
  
  const handleDownload = (fileUrl, title) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = title || "documento.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const nextPdfSlide = () => {
    const totalItems = manuals.length + 1; // +1 por la tarjeta "Agregar"
    if (currentPdfIndex < totalItems - maxVisibleCards) {
      setCurrentPdfIndex(prev => Math.min(prev + maxVisibleCards, totalItems - maxVisibleCards));
    }
  };

  const prevPdfSlide = () => {
    if (currentPdfIndex > 0) {
      setCurrentPdfIndex(prev => Math.max(prev - maxVisibleCards, 0));
    }
  };

  const nextNewsSlide = () => {
    const totalItems = news.length + 1; // +1 por la tarjeta "Crear Noticia"
    if (currentNewsIndex < totalItems - maxVisibleNews) {
      setCurrentNewsIndex(prev => Math.min(prev + maxVisibleNews, totalItems - maxVisibleNews));
    }
  };

  const prevNewsSlide = () => {
    if (currentNewsIndex > 0) {
      setCurrentNewsIndex(prev => Math.max(prev - maxVisibleNews, 0));
    }
  };

  const handleMouseDown = (e, carouselRef) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDragging(false);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e, carouselRef) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e, carouselRef) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };


  const handleTouchMove = (e, carouselRef) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };


  const handleViewDocument = (pdfUrl) => {
    setViewModalUrl(pdfUrl);
    setIsViewModalOpen(true);
  };
  
  const handleDeleteNews = async (newsId) => {
    try {
      const response = await deleteNews(newsId);
      if (response.data && response.data.message) {
        setNews(prev => prev.filter(newsItem => newsItem.id !== newsId));
        setShowNewsDeleteModal(false);
        setNewsToDelete(null);
        setModalMessage("Noticia eliminada correctamente");
        setDeleteNewsSuccess(true);
      }
    } catch (error) {
      console.error("Error deleting news:", error);
      setModalMessage(error.response?.data?.message || "Error al eliminar la noticia");
      setShowModalAlertWarning(true);
      setShowNewsDeleteModal(false);
      setNewsToDelete(null);
    }
  };

  const handleDeleteNewsClick = (newsItem) => {
    setNewsToDelete(newsItem);
    setShowNewsDeleteModal(true);
  };

  const confirmNewsDelete = () => {
    if (newsToDelete) {
      handleDeleteNews(newsToDelete.id);
    }
  };

  const resetNewsForm = () => {
    setNewNewsImage("");
    setNewNewsTitle("");
    setNewNewsDescription("");
  };

  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  const clearFilters = () => {
    setSearchTerm("");
    setIsSearching(false); 
    setIsSearchingNews(false); 
    setDateFilters({
      createDateFrom: "",
      createDateTo: ""
    });
    fetchManuals("", {});
    fetchNews("", {});
  };


  return (
    <div className="min-h-screen">
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 pt-[67px]  bg-[#F7F8F9] w-full z-50 min-h-screen ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
        <div className="sm:pt-8 pt-6 pb-10 px-[5%] sm:px-[3%]">
            <div className="flex flex-col gap-3 ">   
                <div className="flex flex-col items-start justify-between gap-3 sm:items-center sm:flex-row">
                  <h1 className="text-blue font-itcbold  text-2xl md:text-[32px]">
                    Conócenos
                  </h1>
                  <div className="flex flex-col gap-3 sm:flex-row">
                    <FilterInput
                    title="Buscar"
                    placeholder="Buscar por título"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                    />
                    <div className="flex items-center justify-between gap-3">
                      <DateFilterButton
                        onDateRangeChange={handleDateRangeChange}
                        activeFilters={dateFilters}
                        title="Filtrar por fecha de creación"
                      />

                      <ResetFilters
                      onClick={clearFilters}
                      font="font-itcbook"
                      borderColor="border-blue-light"
                      />
                    </div>                    
                  </div>
                </div>
                <h2 className="font-itcmedium text-xl md:text-2xl text-[#6B7280]">
                  Lo que necesitas saber
                </h2>

                {isLoading ? (
                <div className="relative">
                  <div className="grid grid-flow-col items-start pl-4 py-2 auto-cols-[230px] gap-6">
                    <div className="w-[230px]">
                      <div className="flex flex-col justify-center items-center bg-white border-[1px] rounded-lg px-4 border-[#666666] border-dashed drop-shadow-manual h-[320px] w-[230px] opacity-70">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
                          <div className="w-24 h-3 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                      </div>
                    </div>
                    
                    {[...Array(3)].map((_, index) => (
                      <PdfCardLoader key={index} />
                    ))}
                  </div>
                </div>
                ) : error ? (
                <div className="flex items-center justify-center h-64">
                  <p className="text-red-500">{error}</p>
                </div>
                ) : (
                <>

                {isSearching && manuals.length === 0 ? (
                  <div className="flex items-center justify-center h-32 bg-white rounded-lg">
                    <p className="text-lg text-gray-500 font-itcmedium">No se encontraron manuales.</p>
                  </div>
                ) : (
                <div className="relative">
                  {currentPdfIndex > 0 && (
                    <button onClick={prevPdfSlide} className="absolute z-10 transform rotate-180 -translate-y-1/2 cursor-pointer -left-1 sm:-left-2 md:-left-3 lg:-left-4 xl:-left-6 top-1/2">
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}

                  {currentPdfIndex < Math.max(0, (manuals.length + 1) - maxVisibleCards) && (
                    <button 
                      onClick={nextPdfSlide} 
                      disabled={currentPdfIndex >= Math.max(0, (manuals.length + 1) - maxVisibleCards)}
                      className={`absolute -right-3 sm:-right-4 md:-right-5 lg:-right-6 xl:-right-7 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer ${currentPdfIndex >= (manuals.length + 1) - maxVisibleCards ? 'opacity-30' : ''}`}
                    >
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none">
                      <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}

                  <div 
                    ref={pdfCarouselRef}
                    className="overflow-hidden"
                    onMouseDown={(e) => handleMouseDown(e, pdfCarouselRef)}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={(e) => handleMouseMove(e, pdfCarouselRef)}
                    onTouchStart={(e) => handleTouchStart(e, pdfCarouselRef)}
                    onTouchMove={(e) => handleTouchMove(e, pdfCarouselRef)}
                    onTouchEnd={handleMouseUp}
                    >
                      <div 
                        style={{ 
                          transform: `translateX(-${currentPdfIndex * (230 + 24)}px)`,
                          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}
                        className="grid grid-flow-col items-start pl-4  py-2 auto-cols-[230px] gap-6 transition-transform duration-300">
                        {/** AGREGAR MANUAL  */}
                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleFileSelect}
                          accept=".pdf"
                          className="hidden"
                          id="pdf-upload-input"
                        />

                        <label
                          htmlFor="pdf-upload-input"
                          className="flex flex-col w-[230px] items-center justify-center gap-3 cursor-pointer"
                        >
                          <div className="flex flex-col justify-center items-center bg-white border-[1px] rounded-lg px-4 border-[#666666] border-dashed drop-shadow-manual h-[320px] w-[230px]">
                            <div className="flex flex-col items-center justify-center gap-3">
                              <img src={updateImage} alt="Agregar documento"/>
                              <p className="font-itcbook text-[#3F3F3F] text-[10px]">Agregar Documento</p>
                              <p className="text-[10px] pt-3 text-center text-[#6B7280] font-itcbook">
                                Formatos permitidos: PDF <br />
                                Peso máx. {MAX_PDF_SIZE_MB} MB
                              </p>
                            </div>
                          </div>

                        </label>

                        {manuals.map((manual) => (
                          <PdfCard
                            key={manual.id}
                            manualId={manual.id}
                            initialVisible={manual.visible}
                            pdfFile={manual.file}
                            title={manual.title}
                            adminMode={true}
                            onDownloadClick={() => handleDownload(manual.file, manual.title)}
                            onEditClick={() => handleEditClick(manual)}
                            onDeleteClick={() => handleDeleteClick(manual)}
                            onViewClick={() => handleViewDocument(manual.file)}
                            onVisibilityChange={handleVisibilityChange}
                          />
                        ))}
                      </div>
                  </div>
                </div>
                )}
                </>
                )}

                <h2 className="font-itcmedium text-xl md:text-2xl text-[#6B7280]">Noticias</h2>

                {isNewsLoading ? (
                <div className="relative">
                  <div className="grid grid-flow-col auto-cols-[267px] pl-4 py-2 gap-8">
                      <div className="w-[267px] cursor-pointer h-[314px] relative gap-3 flex-col bg-white border-[1px] border-dashed border-[#6B7280] flex drop-shadow-card justify-center items-center rounded-2xl opacity-70">
                        <div className="w-20 h-20 bg-gray-200 rounded-full animate-pulse"></div>
                        <div className="flex items-center justify-center gap-3 pt-2">
                          <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse"></div>
                          <div className="w-20 h-2 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                      </div>
                    
                    {[...Array(2)].map((_, index) => (
                      <NewsCardLoader key={index} />
                    ))}
                  </div>
                </div>
                ) : newsError ? (
                <div className="flex items-center justify-center h-64">
                  <p className="text-red-500">{newsError}</p>
                </div>
                ) : (
                <>
                {isSearchingNews && news.length === 0 ? (
                  <div className="flex items-center justify-center h-32 bg-white rounded-lg">
                    <p className="text-lg text-gray-500 font-itcmedium">No se encontraron noticias.</p>
                  </div>
                ) : (
                <div className="relative">
                  {currentNewsIndex > 0 && (
                    <button onClick={prevNewsSlide} className="absolute z-10 transform rotate-180 -translate-y-1/2 cursor-pointer -left-1 sm:-left-2 md:-left-3 lg:-left-4 xl:-left-6 top-1/2">
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}
                  {currentNewsIndex < Math.max(0, (news.length + 1) - maxVisibleNews) && (
                    <button 
                      onClick={nextNewsSlide} 
                      disabled={currentNewsIndex >= Math.max(0, (news.length + 1) - maxVisibleNews)}
                      className={`absolute -right-3 sm:-right-4 md:-right-5 lg:-right-6 xl:-right-7 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer
                        ${currentNewsIndex >= Math.max(0, (news.length + 1) - maxVisibleNews) ? 'opacity-30' : ''}`}
                    >
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none">
                      <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}

                  <div 
                    ref={newsCarouselRef}
                    className="flex-1 overflow-hidden"
                    onMouseDown={(e) => handleMouseDown(e, newsCarouselRef)}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={(e) => handleMouseMove(e, newsCarouselRef)}
                    onTouchStart={(e) => handleTouchStart(e, newsCarouselRef)}
                    onTouchMove={(e) => handleTouchMove(e, newsCarouselRef)}
                    onTouchEnd={handleMouseUp}
                    >
                      <div 
                        style={{
                          transform: `translateX(-${currentNewsIndex * (267 + 32)}px)`,
                          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}
                        className="grid grid-flow-col auto-cols-[267px] pl-4  py-2 gap-8 transition-transform duration-300">
                        {/**CREAR NOTICIA */}
                        <div
                          onClick={() => setIsCreateNewsModalOpen(true)}
                          className="w-[267px]  cursor-pointer h-[314px] relative gap-3 flex-col bg-white border-[1px] border-dashed border-[#6B7280] flex drop-shadow-card justify-center items-center rounded-2xl">
                            <img src={imageNews} alt="Imagen Noticias"/>
                            <div className="flex items-center justify-center gap-3 pt-2">
                              <img src={updateImage} alt="Agregar documento" className="w-4 h-4"/>
                              <p className="font-itcbook text-[#3F3F3F] text-[10px]">Agregar Noticia</p>
                            </div>
                        </div>

                        {news.map((newsItem) => (
                        <NewsCard
                          adminMode={true}
                          key={newsItem.id}
                          id={newsItem.id}
                          title={newsItem.title}
                          description={newsItem.advance} 
                          image={newsItem.image_list} 
                          date={new Date(newsItem.created_At).toLocaleDateString('es-ES', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })} 
                          onEditClick={() => handleEditNewsClick(newsItem)}
                          onDeleteClick={() => handleDeleteNewsClick(newsItem)} 
                          initialVisible={newsItem.visible}
                          onVisibilityChange={handleNewsVisibilityChange} 
                        />
                        ))}
                      </div>
                  </div>
                </div>
                )}
                </>
                )}
            </div>
        </div>
        {/**ver documento */}
        {isViewModalOpen && viewModalUrl && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="flex flex-col w-[80vw] h-[80vh] bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="flex justify-end p-4 bg-gray-100">
                <button
                  onClick={() => {
                    setIsViewModalOpen(false);
                    setViewModalUrl(null);
                  }}
                  className="text-3xl leading-none text-gray hover:text-gray-700"
                >
                  &times;
                </button>
              </div>
              <div className="flex items-center justify-center flex-1">
                {viewModalError ? (
                  <p className="text-gray-500 font-itcbook">El archivo no existe.</p>
                ) : viewModalBlobUrl ? (
                  <iframe
                    src={viewModalBlobUrl}
                    title="Ver Manual"
                    className="w-full h-full"
                  />
                ) : (
                  <svg className="w-10 h-10 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                )}
              </div>
            </div>
          </div>
        )}

        {isCreateNewsModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[33.33%] sm:w-[50%] w-[95%] h-auto bg-white rounded-3xl shadow-lg flex  flex-col pb-4">
              <div className='flex justify-end'>
                <button
                  onClick={() => {
                    setIsCreateNewsModalOpen(false);
                    resetNewsForm();
                  }}               
                  className="px-4 py-2 rounded-md">
                  <img src={MODALS.CLOSE} alt="cerrar"/>
                </button>
              </div>
              <div className="flex items-center justify-center w-full">
                <div className="flex flex-col items-center gap-2 justify-center w-[267px] py-6">
                  <div className="relative flex items-center justify-center w-full ">
                    <div className="relative flex flex-col items-center justify-center w-[267px] h-[185px] bg-white border border-[#6B7280] border-dashed rounded-2xl" style={{borderWidth: '1px', strokeDasharray: '4,4'}}>
                      {hasImage(newNewsImage) ? (
                        <>
                          <img 
                            src={newNewsImage} 
                            alt="Imagen Noticias" 
                            onError={() => markBroken(newNewsImage)}
                            className="object-fill w-[267px] rounded-2xl h-[185px] "
                          />
                          <label className="absolute flex items-center justify-center p-2 text-white rounded-full cursor-pointer bottom-2 right-2 bg-blue">
                            <input
                              type="file"
                              onChange={handleNewNewsImageSelect}
                              className="hidden"
                              accept=".jpg,.jpeg,.png,.webp,.svg"
                            />
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 21.2852C3.71667 21.2852 3.47933 21.1892 3.288 20.9972C3.09667 20.8052 3.00067 20.5678 3 20.2852V17.8602C3 17.5935 3.05 17.3392 3.15 17.0972C3.25 16.8552 3.39167 16.6428 3.575 16.4602L16.2 3.86016C16.4 3.67682 16.621 3.53516 16.863 3.43516C17.105 3.33516 17.359 3.28516 17.625 3.28516C17.891 3.28516 18.1493 3.33516 18.4 3.43516C18.6507 3.53516 18.8673 3.68516 19.05 3.88516L20.425 5.28516C20.625 5.46849 20.7707 5.68516 20.862 5.93516C20.9533 6.18516 20.9993 6.43516 21 6.68516C21 6.95182 20.954 7.20616 20.862 7.44816C20.77 7.69016 20.6243 7.91082 20.425 8.11016L7.825 20.7102C7.64167 20.8935 7.429 21.0352 7.187 21.1352C6.945 21.2352 6.691 21.2852 6.425 21.2852H4ZM17.6 8.08516L19 6.68516L17.6 5.28516L16.2 6.68516L17.6 8.08516Z" fill="white"/>
                            </svg>
                          </label>
                        </>
                      ) : (
                        <NewsImagePlaceholder onChange={handleNewNewsImageSelect} />
                        
                      )}
                    </div>
                  </div>
  
                  <input
                    type="text"
                    value={newNewsTitle}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setNewNewsTitle(e.target.value);
                      }
                    }}
                    placeholder="Título de la noticia *"
                    className="font-itcmedium w-full text-[20px] outline-none text-[#21243D] border-b border-gray-200"
                    maxLength={50}
                  />
  
                  <textarea
                    value={newNewsDescription}
                    onChange={(e) => setNewNewsDescription(e.target.value)}
                    placeholder="Descripción de la noticia"
                    className="w-full font-itcbook text-xs text-[#1A202C] outline-none  border-b border-gray-200 h-20"
                  />
  
                  <div className="flex items-center justify-between w-full">
                    <p className="text-white font-itcmedium text-[10px] w-[72px] h-[25px] bg-[#EFB86A] rounded-lg py-[6px] px-4">Noticias</p>
                    <p className="bg-[#BBBFCC] text-[#414141] font-itcmedium flex items-center justify-center w-[95px] h-[25px] text-[10px] py-[6px] px-4 rounded-lg">
                      {new Date().toLocaleDateString('es-ES', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </p>
                  </div>
  
                  <button
                    onClick={handleCreateNews}
                    disabled={!newNewsTitle.trim() }
                    className={`mt-6 font-itcbook text-[15px] underline ${
                      !newNewsTitle.trim() 
                      ? 'text-gray-500 cursor-not-allowed' 
                      : 'text-blue'
                    }`}
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <EditPdfModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        pdfFile={editingPdf?.file}
        title={editingTitle}
        onTitleChange={setEditingTitle}
        onSave={handleSaveChanges}
        isSaveDisabled={editingTitle === originalTitle || !editingTitle.trim() || isSaving} 
        isSaving={isSaving} 
      />

      <CreatePdfModal
        isOpen={isCreateModalOpen}
        onClose={() => {
          setIsCreateModalOpen(false);
          resetFileSelection(); 
        }}
        onCreate={handleCreateManual}
        module="Knowus"
        selectedFile={fileToUpload} 
        onFileReset={resetFileSelection} 
      />

      <EditNewsModal
        isOpen={isEditNewsModalOpen}
        onClose={() => setIsEditNewsModalOpen(false)}
        image={editingNewsImage}
        title={editingNewsTitle}
        description={editingNewsDescription}
        date={editingNews?.created_At || ""}
        onImageChange={handleImageChange}
        onTitleChange={setEditingNewsTitle}
        onDescriptionChange={setEditingNewsDescription}
        onSave={handleSaveNewsChanges}
        newsId={editingNews?.id} 
      />

      <ModalDelete
        showModalDelete={showModalDelete}
        closeModal={() => {
          setShowModalDelete(false);
          setManualToDelete(null);
        }}
        accept={confirmDelete}
        textType="manual"
        pronoun="el"
      />

      <ModalSuccess
        showModalSuccess={showModalSuccess}
        closeModalSuccess={() => setShowModalSuccess(false)}
        fill="green" 
        text={modalMessage}
      />

      <ModalSuccess
        showModalSuccess={showEditSuccess}
        closeModalSuccess={() => setShowEditSuccess(false)}
        fill="green" 
        text={editSuccessMessage}
      />
      <ModalAlertWarning
        showModalAlertWarning={showModalAlertWarning}
        closeModal={() => setShowModalAlertWarning(false)}
        error={modalMessage}
        accept={() => setShowModalAlertWarning(false)}
      />

      <ModalDelete
        showModalDelete={showNewsDeleteModal}
        closeModal={() => {
          setShowNewsDeleteModal(false);
          setNewsToDelete(null);
        }}
        accept={confirmNewsDelete}
        textType="noticia"
        pronoun="la"
      />

      <ModalSuccess
        showModalSuccess={deleteNewsSuccess}
        closeModalSuccess={() => {
          setDeleteNewsSuccess(false);
          fetchNews();
        }}    
        fill="green" 
        text={modalMessage}
      />

      <ModalSuccess
        showModalSuccess={showVisibilitySuccess}
        closeModalSuccess={() => setShowVisibilitySuccess(false)}
        fill="green" 
        text={visibilityMessage}
      />

      <ModalSuccess
        showModalSuccess={showNewsVisibilitySuccess}
        closeModalSuccess={() => setShowNewsVisibilitySuccess(false)}
        fill="green" 
        text={newsVisibilityMessage}
      />
      
    </div>
  );
}